import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography } from "@material-ui/core";
import styles from "./styles";
import Question from "../Question";
import "animate.css/animate.css";

const QuestionScreen = (props) => {
  const {
    classes,
    setAnswers,
    questionAnswer,
    nextQuestion,
    modalOpen,
    questionIndex,
    setAnsweredCorrectly,
  } = props;

  // const [answeredCorrectly, setAnsweredCorrectly] = useState(null);
  const [moved, setMoved] = useState(null);
  // const [submitted, setSubmitted] = useState(false);
  const [selected, setSelected] = useState(0);

  useEffect(() => {}, [moved]);

  const handleSubmit = () => {
    questionAnswer.answer === selected
      ? setAnsweredCorrectly(true)
      : setAnsweredCorrectly(false);
    modalOpen(true);
    // setSubmitted(true);
    // questionAnswer.answer.includes('goes') && setTimeout(() => setDottedLineLabels(true), 1000)
  };

  console.log("hello questionIndex: ", questionIndex);

  return (
    <Grid container alignItems="center" direction="column">
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        style={{ flexDirection: "column" }}
      >
        <Grid container className={classes.titleContainer}>
          <Typography
            variant="h3"
            align="center"
            className={`${classes.questionTitle} animate__animated animate__bounceIn`}
          >
            {questionAnswer.title}
          </Typography>
          {/* {selected ? ( */}
            <Button
              onClick={handleSubmit}
              style={{ visibility:  selected ? "visible" : "hidden" }}
              className={`${classes.submitButton} selected animate__animated animate__bounceIn`}
            >
              confirm answer
            </Button>
          {/* ) : (
            <Typography
              variant="h4"
              align="center"
              className={`${classes.belowTitle} animate__animated animate__bounceIn`}
            >
              {questionAnswer.subTitle}
            </Typography>
          )} */}
        </Grid>

        <Grid className={classes.questionComponents}>
          <Question
            selected={selected === 1}
            setSelected={setSelected}
            index={1}
            question={questionAnswer.old}
            anySelected={selected !== 0}
            questionIndex={questionIndex}
            // tagColor
          />
          <Question
            selected={selected === 2}
            setSelected={setSelected}
            index={2}
            question={questionAnswer.new}
            anySelected={selected !== 0}
            questionIndex={questionIndex}
          />
        </Grid>
        {/* {questionIndex === 9 && (
          <Typography className={classes.estimate}>*Estimate</Typography>
        )} */}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(QuestionScreen);
